//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
export default {
  name: "FactorUnitModal",
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: "环境监测因子单位表单",
      tableName: "site_factor_unit",
      form_fields: ['title', 'alias', 'category', 'stand', 'conver', 'status', 'sort', 'remark'],
      form_fields_time: [],
      validatorRules: {
        title: {
          rules: [{
            required: true,
            message: '请输入名称!'
          }]
        },
        conver: {
          rules: [{
            required: true,
            message: '请输入单位转换算法!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请输入状态!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {}
};